import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import FeaturedRiderCard from "../../Rider/FeaturedRiderCard";
import { BrandTeam, Rider } from "../../../types/model";
import FeaturedBrandTeamCard from "../../BrandTeam/FeaturedBrandTeamCard";
import ThreebySixAd from "../../Ads/ThreebySixAd";
import { useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store/store";
import ThreebyThreeAd from "../../Ads/ThreebyThreeAd";

interface HomePageFeaturedLayoutProps {
	featuredRider: Rider; // Replace `any` with the appropriate type for the rider
	featuredBrandTeam: BrandTeam; // Replace `any` with the appropriate type for the brand/team
	featuredRiderDescription?: string;
	featuredBrandTeamDescription?: string;
	selectedSportId?: string;
	selectedSeriesId?: string;
}

const HomePageFeaturedLayout: React.FC<HomePageFeaturedLayoutProps> = ({
	featuredRider,
	featuredBrandTeam,
	featuredRiderDescription,
	featuredBrandTeamDescription,
	selectedSportId,
	selectedSeriesId,
}) => {
	const { isMobile } = useAppSelector((state: RootState) => state.user);
	return (
		<Container fluid>
			<h4 className="text-info text-start mb-4 fw-bold ms-3 fs-2">FEATURED</h4>
			<Row className="g-4">
				<Col xs={12} md={9}>
						<Row className="g-4 justify-content-center align-items-center h-100">
							<Col xs={12}>
								<FeaturedRiderCard
									rider={featuredRider}
									description={featuredRiderDescription}
								/>
							</Col>
							<Col xs={12}>
								<FeaturedBrandTeamCard
									teamId={featuredBrandTeam?._id}
									imageUrl={featuredBrandTeam?.imageUrl ?? ""}
									points={100}
									teamName={featuredBrandTeam?.name}
									description={featuredBrandTeamDescription}
									sportId={selectedSportId}
									seriesId={selectedSeriesId}
								/>
							</Col>
					</Row>
				</Col>
				<Col xs={12} md={3}>
					{isMobile ? <ThreebyThreeAd /> : <ThreebySixAd />}
				</Col>
			</Row>
		</Container>
	);
};

export default HomePageFeaturedLayout;
